import { Simulation } from 'src/app/core/models/simulation.model';
import { BufferGeometry, Color, Line, LineBasicMaterial, Vector3 } from 'three';
import { Catenary3D } from '../../catenary-answer';
import { Line as SimulationLine } from '../../line.model';
import ObjectBuilder from '../object-builders/object-builder.model';

export class LineBuilder extends ObjectBuilder {
  color: Color;
  width: number;

  constructor({ color = null, width = null } = {}) {
    super();
    this.color = color;
    this.width = width;
  }

  private get line(): Line {
    return this._object;
  }

  private set line(line) {
    this._object = line;
  }

  async build(
    riser: Catenary3D,
    _simulation: Simulation,
    simulationLine: SimulationLine,
  ): Promise<any> {
    if (!(riser && riser.meshX && riser.meshY && riser.meshZ)) {
      return null;
    }
    const material = this.createMaterial(null, simulationLine);
    const geometry = this.createGeometry(riser, null);
    this.line = new Line(geometry, material);
    this.line.name = `[${simulationLine.title}].${simulationLine.internalId}`;
    return this.line;
  }

  createGeometry(riser: Catenary3D, _simulationLine: SimulationLine): BufferGeometry {
    const points = [];
    for (let index = 0; index < riser.numNodes; index++) {
      points.push(new Vector3(riser.meshX[index], riser.meshY[index], riser.meshZ[index]));
    }
    return new BufferGeometry().setFromPoints(points);
  }

  createMaterial(_riser: Catenary3D, simulationLine: SimulationLine): LineBasicMaterial {
    return new LineBasicMaterial({
      color: simulationLine.graphicProperties.color,
      linewidth: simulationLine.graphicProperties.width,
    });
  }

  transform(simulationLine: SimulationLine): void {}

  focus(): void {}
}
